const e = "styles-module__numericInput___wFFs5", r = "styles-module__error___zxvjc", s = {
  numericInput: e,
  error: r
};
export {
  s as default,
  r as error,
  e as numericInput
};
